import { afterNextRender, Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlService } from './url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {
  public currentUser:any;
  public token:any;
  constructor(public http:HttpClient,public urlService:UrlService) {
    afterNextRender(() => {
      if(!localStorage.getItem('user')!=null){
        var dt:any=localStorage.getItem('user');
        dt=JSON.parse(dt);
        this.token=dt?.token;
         this.currentUser=dt?.user;
      }
    });


   }

  getHttpOption(isForm?: any):any {
    var token: any = `Bearer ${this.currentUser?.token}`;
    var httpOptions: any = {
      headers: new HttpHeaders({
        accept: '*/*',
        authorization: token || '',
      }),
    };

    if (isForm) {
      // If working with form data, set the appropriate Content-Type
      httpOptions.headers.set('Content-Type', 'multipart/form-data');
    } else {
      // If not working with form data, set the Content-Type for JSON
      httpOptions.headers.set(
        'Content-Type',
        'application/json; charset=utf-8'
      );
    }

    return httpOptions;
  }


  getApiData(url: string): Observable<any> {
    return this.http.get(this.urlService.baseURL + url, this.getHttpOption());
  }


  postApiData(endPoint: string, data: any,isFile?:any): Observable<any> {
    return this.http.post(this.urlService.baseURL + endPoint, data, this.getHttpOption(isFile));
  }

  putApiData(endPoint: string, data: any): Observable<any> {
    return this.http.put(this.urlService.baseURL + endPoint, data, this.getHttpOption());
  }

  deleteApiData(endPoint: string, obj?: any): Observable<any> {
    const options = {
        headers: this.getHttpOption().headers, // Include headers if needed
        body: obj // Add the object to the body if it's required by the API
    };
    return this.http.delete(this.urlService.baseURL + endPoint, options);
}
}
